import React, { Component } from "react";
import { Link } from "react-router-dom";

class Contact extends Component {
  render() {
    return (
      <div>
        <article class="post">
          <header>
            <div class="title">
              <h2>
                <a href="single.html">Contact</a>
              </h2>
            </div>
          </header>
          <p>
            <p>
              <strong>Ryan Pearlman</strong>

              <br />
              <a href="mailto:pearlman.ryan@gmail.com">
                pearlman.ryan@gmail.com
              </a>
              <br />
              <a href="tel:2144606403">(214) - 460 - 6403</a>
            </p>
            <p>
              For web development inquiries please refer to my company website or contact me at my work email.
              <br />
              <a href="https://www.ensignconsultants.com" target="_blank">
                EnsignConsultants.com
              </a>
              <br />
              <a href="mailto:ryan@ensignconsultants.com">
                ryan@ensignconsultants.com
              </a>
            </p>
          </p>

          <ul class="icons">
            <li>
              <a
                href="https://www.linkedin.com/in/ryan-pearlman-511344a6/"
                class="fa-linkedin"
                target="_blank"
              >
                <span class="label">LinkedIn</span>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/pearlmanryan"
                class="fa-twitter"
                target="_blank"
              >
                <span class="label">Twitter</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/ryan.pearlman.73"
                class="fa-facebook"
                target="_blank"
              >
                <span class="label">Facebook</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/pearlman.ryan/"
                class="fa-instagram"
                target="_blank"
              >
                <span class="label">Instagram</span>
              </a>
            </li>
            <li>
              <a
                href="mailto:pearlman.ryan@gmail.com"
                class="fa-envelope"
                target="_blank"
              >
                <span class="label">Email</span>
              </a>
            </li>
          </ul>
        </article>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js